import axios from 'axios';
import { ICrudSearchAction, ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { ISponsor, defaultValue } from '../../model/sponsor.model';

export const ACTION_TYPES = {
  SEARCH_SPONSORS: 'sponsor/SEARCH_SPONSORS',
  FETCH_SPONSOR_LIST: 'sponsor/FETCH_SPONSOR_LIST',
  FETCH_SPONSOR: 'sponsor/FETCH_SPONSOR',
  CREATE_SPONSOR: 'sponsor/CREATE_SPONSOR',
  UPDATE_SPONSOR: 'sponsor/UPDATE_SPONSOR',
  DELETE_SPONSOR: 'sponsor/DELETE_SPONSOR',
  SET_BLOB: 'sponsor/SET_BLOB',
  RESET: 'sponsor/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ISponsor>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type SponsorState = Readonly<typeof initialState>;

// Reducer

export default (state: SponsorState = initialState, action): SponsorState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.SEARCH_SPONSORS):
    case REQUEST(ACTION_TYPES.FETCH_SPONSOR_LIST):
    case REQUEST(ACTION_TYPES.FETCH_SPONSOR):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_SPONSOR):
    case REQUEST(ACTION_TYPES.UPDATE_SPONSOR):
    case REQUEST(ACTION_TYPES.DELETE_SPONSOR):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.SEARCH_SPONSORS):
    case FAILURE(ACTION_TYPES.FETCH_SPONSOR_LIST):
    case FAILURE(ACTION_TYPES.FETCH_SPONSOR):
    case FAILURE(ACTION_TYPES.CREATE_SPONSOR):
    case FAILURE(ACTION_TYPES.UPDATE_SPONSOR):
    case FAILURE(ACTION_TYPES.DELETE_SPONSOR):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.SEARCH_SPONSORS):
    case SUCCESS(ACTION_TYPES.FETCH_SPONSOR_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_SPONSOR):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_SPONSOR):
    case SUCCESS(ACTION_TYPES.UPDATE_SPONSOR):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_SPONSOR):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.SET_BLOB: {
      const { name, data, contentType } = action.payload;
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType,
        },
      };
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/sponsors';
const apiSearchUrl = 'api/_search/sponsors';

// Actions

export const getSearchEntities: ICrudSearchAction<ISponsor> = (query, page, size, sort) => ({
  type: ACTION_TYPES.SEARCH_SPONSORS,
  payload: axios.get<ISponsor>(`${apiSearchUrl}?query=${query}${sort ? `&page=${page}&size=${size}&sort=${sort}` : ''}`),
});

export const getEntities: ICrudGetAllAction<ISponsor> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_SPONSOR_LIST,
    payload: axios.get<ISponsor>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<ISponsor> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_SPONSOR,
    payload: axios.get<ISponsor>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<ISponsor> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_SPONSOR,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<ISponsor> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_SPONSOR,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<ISponsor> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_SPONSOR,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType,
  },
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
